/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ISteps {
  stepDescription?: string;
  stepImage?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Steps extends Component {
  private readonly stepList: ISteps[] = [
    {
      stepDescription:
        'colored felt<br/>elastic roll<br/>scissors<br/>hot glue gun & glue<br/>their favorite doll, like the Cabbage Patch Kids 14” Celebration doll',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xsj',
    },
    {
      stepDescription:
        'Parent-only step: Measure and cut two strips of elastic long enough to fit as shoulder straps around child. Cut another piece of elastic wide enough to keep the doll secure.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xsk',
    },
    {
      stepDescription:
        'Design and cut decorations out of felt for the back of the carrier.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Urw',
    },
    {
      stepDescription:
        'Parent-only step: Choose one sheet of felt tall and wide enough for the doll to fit. Hot glue decorations to one side; glue shoulder straps and doll support to the other side.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYF',
    },
    {
      stepDescription:
        'When glue dries, slip in the doll and it’s ready for happy travels!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYG',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <h5 className='diy-small-heading-padding0'>What You’ll Need:</h5>

          {this.stepList.map((item) => (
            <React.Fragment>
              <div className='col-lg-12 col-md-12'>
                <div className='step-text'>
                  <p>{ReactHtmlParser(item.stepDescription)}</p>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='step-image'>
                  <img
                    className='img-responsive'
                    src={item.stepImage}
                    alt='bay doll sleeping bag'
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default Steps;
